import { fileDownload } from 'utils/fileDownload';
import { logError } from 'utils/sentryUtils';

import { mmFetch } from './mmFetch';
import { mmFetchWithResponse } from './mmFetchWithResponse';

const outboundTruckApi = {
    createTruck: async (item) => {
        const url = `api/logistics/v1/outbound/trucks`;
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(item),
        });
        return response;
    },
    getDoors: async (facilityID) => {
        const url = `api/logistics/v1/outbound/doors?facility=${facilityID}`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getManifestableTrucks: async (facilityID) => {
        const url = `api/logistics/v1/outbound/manifestableTrucks?facilityID=${facilityID}`;
        return mmFetchWithResponse(url);
    },
    getTrucks: async (facilityID) => {
        const url = `api/logistics/v1/outbound/trucks?facilityID=${facilityID}`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getTruckDelayReasons: async () => {
        const url = `api/logistics/v1/outbound/truckDelayReasons`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getDoorTag: async (id) => {
        const url = `api/logistics/v1/outbound/doors/${id}/label`;
        const filename = `outbound_door_${id}.pdf`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                await fileDownload(res, filename);
            }
        } catch (e) {
            logError(e);
        }
    },
    manifestTruck: async (outboundTruckID) => {
        const url = `api/logistics/v1/outbound/manifestableTrucks`;
        const sendParams = {
            outboundTruckID,
        };
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(sendParams),
        });
        return response;
    },
    updateTruck: async (id, sendParams) => {
        const url = `api/logistics/v1/outbound/trucks/${id}`;
        const response = await mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify(sendParams),
        });
        return response;
    },
};

export { outboundTruckApi };
